import type { HTMLAttributes } from 'react'

import { useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { MaterialIcons } from '@monthio/react-components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'
import { SecondaryButton } from '@monthio/design-system'

const AddButtonWrapper = styled.div<{ $fullwidth: boolean }>`
	> button {
		${(p) =>
			p.$fullwidth &&
			css`
				width: 100%;
			`}
	}
`

export const AddButton: React.FC<
	{ onAdd: () => void; title?: string } & HTMLAttributes<HTMLDivElement>
> = ({ onAdd, title, ...domAttributes }) => {
	const { t } = useTranslation()
	const theme = useTheme()
	const fullwidth = useMediaQuery(theme.breakpoints.down('xs'))

	return (
		<AddButtonWrapper {...domAttributes} $fullwidth={fullwidth}>
			<SecondaryButton
				id={'add-asset-${assetType}'}
				type="button"
				onClick={onAdd}
			>
				<MaterialIcons.Add />
				{title || t('debtOverview-summary-add-creditor')}
			</SecondaryButton>
		</AddButtonWrapper>
	)
}
